export default [
    {
        path: '/admin/ayuda',
        meta: { nombre: 'información para los usuario' },
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/ayuda').then(m => m.default || m),
        children: [
            {
                path: 'consultas-frecuentes',
                name: 'admin.ayuda.frecuentes',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/ayuda/preguntas-frecuentes').then(m => m.default || m),
            },
            {
                path: 'terminos-condiciones',
                name: 'admin.ayuda.terminos-condiciones',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/ayuda/terminos-condiciones').then(m => m.default || m),
            },
            {
                path: 'politica-privacidad',
                name: 'admin.ayuda.politica-privacidad',
                component: () => import(/* webpackChunkName: "informacion" */ '../../pages/ayuda/politica-privacidad').then(m => m.default || m),
            }
        ]
    }
]
